<template>
    <div class="component">
        <vue-headful
                :title="title + ' | W&S Docs'"
        />
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb bg-dark">
                <li class="breadcrumb-item">
                    <router-link to="/methods">Methods</router-link>
                </li>
                <li class="breadcrumb-item active">
                    {{ title }}
                </li>
            </ol>
        </nav>
        <ul class="list-group list-group-flush">
            <li class="list-group-item bg-dark d-flex align-items-center justify-content-between mb-2"
                v-for="(preview) in previews" :key="preview.preview_id">
                <div class="form-group m-0">
                    <router-link :to="'/methods/preview/' + qtheme_id">
                        Введение в {{ preview.preview_title }}
                    </router-link>
                    <small class="form-text text-muted">{{ preview.preview_desc }}</small>
                </div>
            </li>
            <li class="list-group-item bg-dark d-flex align-items-center justify-content-between"
                v-for="(method) in methods" :key="method.method_id">
                <div class="form-group m-0">
                    <router-link :to="'/methods/' + method.theme_link + '/' + method.method_link">{{ method.method_link
                        }}
                    </router-link>
                    <small class="form-text text-muted">{{ method.method_desc }}</small>
                </div>
            </li>
        </ul>

    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "MethodsThemeList",
        props: ['qtheme_id'],
        data() {
            return {
                loading: true,
                result: false,
                methods: [],
                themes: [],
                previews: [],
                title: null,
            }
        },
        mounted() {
            axios.get('https://api.write-and-share.ml/docs/method.get?method_theme=' + this.qtheme_id)
                .then(response => {
                    this.methods = response.data.response
                });
            axios.get('https://api.write-and-share.ml/docs/theme.get?theme_link=' + this.qtheme_id)
                .then(response => {
                    this.themes = response.data.response;
                    this.title = response.data.response[0].theme_title;
                });
            axios.get('https://api.write-and-share.ml/docs/preview.get?preview_theme=' + this.qtheme_id)
                .then(response => {
                    this.previews = response.data.response;
                });
            this.loading = false;
        },
    }
</script>

<style scoped>

</style>
